import * as api from '@/api'
import * as cookie from '@/api/cookie'
import config from '../../config/config'

import { instance } from '@/api'

const auth = {
  namespaced: true,
  state: {
    token: '',
    /*
      status
      'unauthenticated' : default, 認証前
      'authenticated' : 認証完了
      'unabled' : 認証情報不足
      'failed' : 認証失敗
      'quitted' : 認証終了
    */
    status: 'unauthenticated',
    errorMessage: '',
  },
  getters: {
    getToken: (state) => {
      return state.token
    },
    getStatus: (state) => {
      return state.status
    },
    getIsUnauthenticated: (state) => {
      return state.status === 'unauthenticated'
    },
    getIsAuthenticated: (state) => {
      return state.status === 'authenticated'
    },
    getIsAuthUnabled: (state) => {
      return state.status === 'unabled'
    },
    getIsAuthFailed: (state) => {
      return state.status === 'failed'
    },
    getIsAuthQuitted: (state) => {
      return state.status === 'quitted'
    },
    getErrorMessage: (state) => {
      return state.errorMessage
    },
  },
  actions: {
    createAuth: async ({ commit, rootGetters }, { id, token }) => {
      const language = rootGetters['setting/getLanguage']
      if (!id && !token) {
        commit('setAuth', 'unabled')
        return
      }
      try {
        const { data } = await api.createAuth(id, token)
        if (!data?.accessToken) {
          // 202が10回以上続いた場合
          commit('createAuthAborted', config.errorMessages[202][language])
          return
        }
        instance.defaults.headers['soAuthToken'] = data.accessToken
        cookie.saveToken(data.accessToken)
        commit('createAuthDone', data.accessToken)
      } catch (err) {
        if (err.response) {
          if (err.response.status === 403) {
            commit('createAuthFailed', err.response.data.message)
            return
          }
          if (500 <= err.response.status) {
            commit(
              'createAuthFailed',
              `${config.errorMessages.server[language]}(${err.response.status})`
            )
            return
          }
          // QRコードのバリデーションエラー等
          commit('createAuthFailed', config.errorMessages.others[language])
          return
        } else {
          // Network error or Timeout
          // SOではtimeoutの秒数未指定なので、実質Network errorのみ
          commit('createAuthFailed', config.errorMessages.others[language])
          return
        }
      }
    },
    deauth: async ({ commit, dispatch, rootGetters }) => {
      const shopId = rootGetters['seat/getShopId']
      const seatNo = rootGetters['seat/getSeatNo']
      try {
        await api.deauth(shopId, seatNo)
      } catch {
        //
      }
      dispatch('seat/resetAll', null, { root: true })
      commit('deauth')
      cookie.removeToken()
    },
    setToken: ({ commit }, { token }) => {
      instance.defaults.headers['soAuthToken'] = token
      commit('createAuthDone', token)
    },
    setAuth: ({ commit }, status) => {
      commit('setAuth', status)
    },
  },
  mutations: {
    createAuthDone(state, soAuthToken) {
      state.token = soAuthToken
      state.status = 'authenticated'
    },
    createAuthFailed(state, message) {
      state.errorMessage = message
      state.status = 'failed'
    },
    createAuthAborted(state, message) {
      state.errorMessage = message
      state.status = 'failed'
    },
    deauth(state) {
      state.token = ''
      state.status = 'quitted'
    },
    setAuth(state, status) {
      state.status = status
    },
  },
}

export default auth
